import { gql } from "@apollo/client";
import type { SelectOptionType } from "graphql/types/SelectOptionType";

/**
 * 获取价格方案应用的操作人下拉选项列表，按业务场景过滤
 */
export const LIST_PRICING_SCHEME_APPLY_OPERATOR_OPTIONS = gql`
    query ListPricingSchemeApplyOperatorOptions($businessScenario: Long) {
        listPricingSchemeApplyOperatorOptions(businessScenario: $businessScenario) {
            value
            label
        }
    }
`;

export interface ListOperatorOptionsVariables {
    businessScenario?: number | null;
}

export interface ListOperatorOptionsResponse {
    listPricingSchemeApplyOperatorOptions: SelectOptionType[];
}

